import { render } from "./EditProjectTask.vue?vue&type=template&id=40ca915b"
import script from "./EditProjectTask.vue?vue&type=script&lang=js"
export * from "./EditProjectTask.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/menejar/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__